module.exports = __webpack_public_path__ + "static/media/06_blanco.ca6e13fc.svg";